/**
 * moo-cart-shots.js — image swiper for the cart drawer "complete the look" row.
 *
 * Loaded from layout/theme.liquid rather than inlined in `moo-cart-upsell`,
 * because that snippet only renders when the cart is NOT empty. A shopper who
 * lands on a page with an empty cart and then adds an item gets the drawer back
 * from the Section Rendering API — and a <script> tag injected that way never
 * executes, so the arrows were dead in exactly the most common flow.
 *
 * Listeners are delegated on document, so they survive every drawer re-render.
 * Both arrows are always visible, so the ends wrap around instead of disabling.
 *
 * Moonell · 2026-08-10
 */
(() => {
  if (window.mooCartShotsReady) return;
  window.mooCartShotsReady = true;

  const EPS = 2;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    const btn = target.closest('[data-moo-shots-nav]');
    if (!btn) return;

    const frame = btn.closest('[data-moo-shots]');
    const track = frame && frame.querySelector('[data-moo-shots-track]');
    if (!track) return;

    event.preventDefault();
    event.stopPropagation();

    const step = Number(btn.dataset.mooShotsNav);
    const max = track.scrollWidth - track.clientWidth;
    if (max <= EPS) return;

    let left;
    if (step < 0 && track.scrollLeft <= EPS) {
      left = max;
    } else if (step > 0 && track.scrollLeft >= max - EPS) {
      left = 0;
    } else {
      left = track.scrollLeft + track.clientWidth * step;
    }

    track.scrollTo({
      left,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  });
})();
